import React from "react";
import Slider from "react-slick";
import { whatsapp_links } from "../../util/whatsapp";

// Componentes customizados para as setas
function PrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <button
      className={className}
      style={{ ...style, display: "block", zIndex: 1 }}
      onClick={onClick}
      aria-label="Slide anterior"
      title="Slide anterior"
      type="button"
    >
      <i className="fas fa-arrow-left"></i>
    </button>
  );
}

function NextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <button
      className={className}
      style={{ ...style, display: "block", zIndex: 1 }}
      onClick={onClick}
      aria-label="Próximo slide"
      title="Próximo slide"
      type="button"
    >
      <i className="fas fa-arrow-right"></i>
    </button>
  );
}

function ProductSliderV2() {
  let publicUrl = process.env.PUBLIC_URL + "/";

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          arrows: false,
          dots: false
        }
      },
      {
        breakpoint: 992,
        settings: {
          arrows: true,
          dots: false,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          dots: false,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 580,
        settings: {
          arrows: true,
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  const categories = [
    {
      icon: "fas fa-wrench",
      number: "01",
      title: "Ferramentas",
      description: "As ferramentas certas fazem o trabalho ficar mais fácil. Descubra nossa seleção de ferramentas de qualidade para tornar cada tarefa uma brisa.",
      link: whatsapp_links.ferramentas
    },
    {
      icon: "fas fa-screwdriver",
      number: "02",
      title: "Fixação",
      description: "Fixe com confiança! Encontre uma variedade de produtos de fixação robustos e duráveis para manter tudo no lugar",
      link: whatsapp_links.fixadores
    },
    {
      icon: "fas fa-flask",
      number: "03",
      title: "Químicos",
      description: "Explore nossa gama de produtos químicos confiáveis para manter tudo funcionando suavemente. Da limpeza à manutenção, temos o que você precisa.",
      link: whatsapp_links.quimicos
    },
    {
      icon: "fas fa-truck-fast",
      number: "04",
      title: "Conheça nosso estoque",
      description: "Descubra um mundo de possibilidades em nosso estoque completo. Explore agora e encontre o que você precisa para fazer negócios de forma eficaz e eficiente!",
      link: whatsapp_links.estoque
    }
  ];

  return (
    <>
      <div className="background-top-fade"></div>
      <div
        id="products"
        className="ltn__search-by-place-area before-bg-top bg-image-top--- pt-115 pb-70"
        data-bs-bg={publicUrl + "assets/img/bg/20.jpg"}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title-area ltn__section-title-2--- text-center---">
                <h6 className="section-subtitle section-subtitle-1--- ltn__secondary-color text-align-center">
                  Produtos
                </h6>
                <h1 className="section-title text-align-center">
                  Mais de 7 mil produtos de diferentes segmentos
                </h1>
              </div>
            </div>
          </div>
          <div className="row go-top">
            <div className="col-lg-12">
              <Slider {...sliderSettings} className="ltn__search-by-place-slider-1-active">
                {categories.map((category, index) => (
                  <div key={index} className="col-md-4 col-sm-6 col-6">
                    <div className="product-item ltn__category-item ltn__category-item-5 ltn__category-item-5-2 text-center---">
                      <a
                        href={category.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <span className="category-icon">
                          <i className={category.icon}></i>
                        </span>
                        <span className="category-number">{category.number}</span>
                        <span className="category-title">{category.title}</span>
                        <span className="category-brief">
                          {category.description}
                        </span>
                      </a>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProductSliderV2;
